import {
  SHOW_MODAL,
  CLEAR_MODAL,
  SHOW_NOTIFICATION,
  CLEAR_NOTIFICATION,
  GLOBAL_REQ_CANCEL
} from './Types';

/**
 * First cancels existing/in process API actions, then fires off an action
 * @param  {[type]} action [description]
 * @return [type]          [description]
 */
export const cancelApiActionsAndFire = action => {
  return dispatch => {
    dispatch({
      type: GLOBAL_REQ_CANCEL
    });
    dispatch(action);
  };
};

/**
 * Cancel API actions
 */
export const cancelApiActions = () => ({
  type: GLOBAL_REQ_CANCEL
});

/**
 *
 * @param {*} type
 * @param {*?} initialValue
 */
export const showModal = (type, initialValue) => {
  return dispatch => {
    const action = {
      type: SHOW_MODAL,
      payload: {
        type,
        initialValue
      }
    };

    dispatch(action);
  };
};

/**
 * Cancel a modal
 */
export const clearModal = type => {
  return dispatch => {
    const action = {
      type: CLEAR_MODAL,
      payload: type
    };

    dispatch(action);
  };
};

/**
 * Show a notification
 */
export const showNotification = (message, options) => {
  return dispatch => {
    const action = {
      type: SHOW_NOTIFICATION,
      payload: {
        show: true,
        message,
        options
      }
    };

    dispatch(action);

    setTimeout(() => {
      dispatch(clearNotification(message));
    }, 4000);
  };
};

/**
 * Clear a notification
 */
export const clearNotification = message => {
  return dispatch => {
    const action = {
      type: CLEAR_NOTIFICATION,
      payload: {
        show: false,
        message: message
      }
    };

    dispatch(action);
  };
};
